<template>
  <b-modal
    id="recommendation"
    :modal-class="`modal-recommendation`"
    ref="modal"
    hide-footer
  >
    <b-row>
      <b-col cols="0" lg="1" class="ml-2 p-0">
        <div
          class="metric-col"
          v-for="(metrics, index) in recommendationPost.metrics"
          :key="`metricsIcon${index}`"
        >
          <img v-if="metrics.image" class="metric-image" :src="metrics.image" />
          <div class="metric-name">
            {{ metrics.label }}
          </div>
        </div>
      </b-col>
      <b-col cols="12" lg="10" class="content-col">
        <h1>{{ recommendationPost.title }}</h1>
        <div class="metric-div">
          <div
            class="metric-icon"
            v-for="(metrics, index) in recommendationPost.metrics"
            :key="`metricLine${index}`"
          >
            <span v-if="index !== 0" class="pl-2 pr-1">⦁</span>
            <img v-if="metrics.image" :src="metrics.image" />
            {{ metrics.label }}
          </div>
        </div>
        <img
          v-if="recommendationPost.image"
          class="banner"
          :src="recommendationPost.image"
        />

        <br /><br />

        <img class="post-icon top" src="/icons/recommendation/what-icon.svg" />
        <h3 v-html="recommendationPost.body.what.title"></h3>
        <p v-html="recommendationPost.body.what.content"></p>

        <br />

        <img class="post-icon" src="/icons/recommendation/how-icon.svg" />
        <h3 v-html="recommendationPost.body.how.title"></h3>
        <b-row>
          <b-col
            class="square"
            cols="12"
            md="6"
            v-for="(item, index) in recommendationPost.body.how.content"
            :key="`itemText${index}`"
          >
            <b-row class="square-item">
              <b-col class="circle" cols="1">
                <div class="circle-number">{{ index + 1 }}</div>
              </b-col>
              <b-col class="item-text pr-1" cols="11">
                <p v-html="item"></p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <br />

        <img class="post-icon" src="/icons/recommendation/benefit-icon.svg" />
        <h3 v-html="recommendationPost.body.benefit.title"></h3>
        <p v-html="recommendationPost.body.benefit.content"></p>

        <template
          v-if="recommendations$ && recommendations$.length && showCarousel"
        >
          <br />
          <hr />
          <br />
          <h3>{{ `${resources.moreRecommendations} ${metricsName}` }}</h3>
          <RecommendationCarousel
            :recommendations="recommendations$"
            @recommendationButtonClicked="recommendationButtonClicked"
          />
        </template>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import RecommendationCarousel from '@/components/RecommendationCarousel.vue'
import { pluck, switchMap, filter, map } from 'rxjs/operators'
import { from, combineLatest } from 'rxjs'
import { getRecommendations } from '@/service/recommendation'
import { APP_MODAL_OPEN, RECOMMENDATION } from '@/components/Modal/Enum'

export default {
  components: {
    RecommendationCarousel,
  },
  subscriptions() {
    const metrics$ = this.$watchAsObservable('recommendationPost').pipe(
      pluck('newValue', 'metrics')
    )
    const metricIds$ = metrics$.pipe(
      map(metrics => metrics.map(metric => metric.id)),
      filter(id => id)
    )
    const postId$ = this.$watchAsObservable('postId').pipe(pluck('newValue'))

    const recommendations$ = combineLatest(metricIds$, postId$).pipe(
      switchMap(([metricIds, postId]) => {
        return from(getRecommendations(metricIds.join(','), postId))
      })
    )

    return {
      metricIds$,
      recommendations$,
    }
  },
  data() {
    return {
      classFix: null,
      showCarousel: false,
    }
  },
  computed: {
    ...mapGetters({
      recommendationPost: 'recommendation/post',
    }),

    ...mapGetters({
      resources: 'recommendationPost',
    }),

    metricsName() {
      const names = this.recommendationPost.metrics.map(m => m.label)
      if (names.length === 1) return names[0]
      const [lastName, ...tail] = names.slice().reverse()

      return tail.join(', ') + this.resources.and + lastName
    },

    postId() {
      return this.recommendationPost.id
    },
  },
  methods: {
    validate() {},
    open() {
      this.$refs.modal.show()
      this.showCarousel = true
    },
    recommendationButtonClicked(recommendation) {
      this.$root.$emit(APP_MODAL_OPEN, { modal: RECOMMENDATION })
      this.$store.dispatch('recommendation/initializePost', {
        title: recommendation.title,
        image: recommendation.image,
        metrics: recommendation.metrics,
      })
      this.$store.dispatch(
        'recommendation/getRecommendationById',
        recommendation.id
      )
      this.$refs.modal.hide()
      document.getElementById('recommendation').scrollTop = 0
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.modal-recommendation {
  .modal-content {
    border-top: 4px solid map-get($theme-colors, 'purple08');
  }

  .modal-dialog {
    max-width: 1000px;
    min-width: unset;
    padding: 0px 40px;

    @media (max-width: 767px) {
      padding: 0px 10px;
    }
  }

  .modal-header {
    background-color: unset;
    border: unset;
    padding-bottom: 0px;

    .close {
      color: map-get($theme-colors, 'primary');
      box-shadow: 0px 1px 0px 3px rgba(61, 90, 254, 0.1);
      width: 38px;
      height: 38px !important;
      font-weight: initial;
      min-height: initial;
      min-width: initial;
      padding: unset;
      margin: 10px;
      margin-top: 20px;
      z-index: 1;
    }
  }

  .modal-body {
    padding-top: 0px;
    top: -55px;

    .metric-col {
      display: flex;
      flex-direction: column;

      @media (max-width: 991px) {
        display: none;
      }

      .metric-image {
        max-height: 55px;
      }

      .metric-name {
        text-align: center;
        margin-top: 5px;
        font-size: 0.7rem;
      }
    }

    .content-col {
      @media (max-width: 991px) {
        padding: 0px 20px;
      }
      h1 {
        color: map-get($theme-colors, 'purple08');
        text-align: center;
        font-size: 45px;
        margin-bottom: 30px;

        @media (max-width: 1199px) {
          padding-left: 60px;
          padding-right: 60px;
          margin-bottom: 10px;
        }

        @media (max-width: 425px) {
          font-size: 30px;
        }

        @media (max-width: 350px) {
          font-size: 25px;
        }
      }

      h3 {
        color: map-get($theme-colors, 'primary');
        text-align: center;
        font-size: 30px;

        @media (max-width: 425px) {
          font-size: 20px;
        }
      }

      p {
        color: map-get($theme-colors, 'gray03');
        font-size: 14px;

        @media (max-width: 425px) {
          font-size: 12px;
        }
      }
      .metric-div {
        display: flex;
        justify-content: center;

        .metric-icon {
          margin-bottom: 1rem;
          text-align: center;
          color: map-get($theme-colors, 'primary');
          font-size: 19px;

          @media (min-width: 992px) {
            display: none;
          }

          @media (max-width: 425px) {
            font-size: 14px;
          }

          img {
            width: 17px;
            vertical-align: initial;

            @media (max-width: 425px) {
              width: 13px;
            }
          }
        }
      }

      .banner {
        width: 100%;
        border-radius: 8px;
      }

      .post-icon {
        display: block;
        margin-left: auto;
        margin-right: auto;

        &.top {
          margin-top: -80px;
        }

        @media (max-width: 425px) {
          width: 70px;

          &.top {
            margin-top: -65px;
          }
        }
      }

      .square {
        display: flex;
        flex-grow: 1;
        max-width: initial;
        padding: 0;
        width: 50%;

        .square-item {
          background-color: map-get($theme-colors, 'light');
          border-radius: 8px;
          margin: 10px;
          padding: 10px;
          width: 100%;

          .circle {
            padding: 0px;
            flex-grow: 1;
            max-width: 25px;

            .circle-number {
              background-color: map-get($theme-colors, 'purple08');
              border-radius: 9px;
              width: 18px;
              height: 18px;
              font-size: 12px;
              color: white;
              font-weight: 500;
              text-align: center;
            }
          }

          .item-text {
            padding: 0px;

            @media (max-width: 374px) {
              padding-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
